/**
 * Document language switching.
 *
 * Both languages are already in the page. Switching sets one attribute and CSS
 * does the rest, so there is no request, no flash, and a visitor with no
 * JavaScript still sees the language the server chose — the one that has files.
 */
class KarvingerDocLibrary extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const pick = event.target.closest('[data-lang-pick]');
    if (!pick || pick.disabled) return;
    this.setLanguage(pick.dataset.langPick);
  };

  setLanguage(lang) {
    this.dataset.lang = lang;
    this.querySelectorAll('[data-lang-pick]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.langPick === lang));
    });
  }
}

if (!customElements.get('karvinger-doc-library')) {
  customElements.define('karvinger-doc-library', KarvingerDocLibrary);
}
